var _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDiff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 100,
    viewBox: "0 0 160 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 24,
    width: 24,
    height: 32,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 24,
    width: 24,
    height: 32,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 16,
    x2: 80,
    y2: 72,
    strokeDasharray: "3 3"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 90,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "currentColor"
  }, "\n        No Diff Found\n    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDiff);
export default __webpack_public_path__ + "static/media/noDiff.75d19a424b56b8e79f2feab9cb17b2b6.svg";
export { ForwardRef as ReactComponent };